import { Injectable, Injector } from '@angular/core';
import { CrudService } from '../crud/crud.service';
import { ReminderDto } from '@authority-labs/api-interfaces';
import { Path } from '@authority-labs/enums';
import { Observable } from 'rxjs';
import { GetManyDefaultResponse } from '@nestjsx/crud';

@Injectable({
  providedIn: 'root'
})
export class ReminderService extends CrudService<ReminderDto> {
  constructor(injector: Injector) {
    super(injector, Path.Reminders, ReminderDto);
  }

  getUsersReminders(
    params: string
  ): Observable<GetManyDefaultResponse<ReminderDto>> {
    return this.http.get<GetManyDefaultResponse<ReminderDto>>(
      `${this.api}/user?${params}`
    );
  }
}
